<template>
<div class="login_wraps">
  <div class="container">
    <div class="form_complete">
         <h2>Complete your information</h2>
        <div class="row">
             <div class="col-md-12">
                <div class="center content-inputs wrapfields">
                      <div class="center content-inputs">
                       <vs-input v-model="email"  placeholder="vuesax@gmail.com">
                        <template v-if="validEmail" #message-success>
                        Email Valid
                        </template>
                        <template v-if="!validEmail && email !== ''" #message-danger>
                        Email Invalid
                        </template>
                    </vs-input>
                        </div>
                    </div>
            </div>
            <div class="col-md-6">
                 <div class="center content-inputs wrapfields">
                      <div class="center content-inputs">
                        <vs-input  v-model="name" placeholder="Your Name" />
                        </div>
                    </div>
            </div>
            <div class="col-md-6">
                <div class="center content-inputs wrapfields">
                      <div class="center content-inputs">
                        <vs-input v-model="address" placeholder="Address" />
                        </div>
                    </div>
            </div>
            <div class="col-md-6">
                <div class="center content-inputs wrapfields">
                      <div class="center content-inputs">
                        <vs-input v-model="city" placeholder="City" />
                        </div>
                    </div>
            </div>
            <div class="col-md-6">
                <div class="center content-inputs wrapfields">
                      <div class="center content-inputs">
                        <vs-input v-model="postal_code" placeholder="Postal Code" />
                        </div>
                    </div>
            </div>
            <div class="col-12">
                 <vs-button
                @click.native="submit_completeAccount()"
                color="#343a40"
                gradient
                square
                :loading="loading_comp"
                :disabled="!validEmail || name=='' || email=='' || city=='' || address=='' || postal_code==''"
                >
                <span>Save</span>
                </vs-button>
            </div>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "CompleteAccountApp",
  data(){
    return{
        name:'',
        address:'',
        city:'',
        postal_code:'',
        email:'',
        loading_comp:false,
    }
  },
  computed:{
     validEmail() {
            return /[a-zA-Z0-9.]*@[a-z]*[.a-z]*/.test(this.email);
        },
    ...mapGetters({
        user:'auth/user',
        authenticated:'auth/authenticated',
    })
  },
  methods:{
    ...mapActions({
        complete_Account_api:'complete_Account_api'
    }),
    fill_data(){
        console.log(this.user)
        if(this.user.name !=null){
            this.name = this.user.name;
        }
         if(this.user.email !=null){
            this.email = this.user.email;
        }
         if(this.user.address !=null){
            this.address = this.user.address;
        }
         if(this.user.city !=null){
            this.city = this.user.city;
        }
         if(this.user.postal_code !=null){
            this.postal_code = this.user.postal_code;
        }
    },
    submit_completeAccount(){
        this.loading_comp = true;
        let userdata = {
        'name': this.name,
        'address':this.address,
        'city':this.city,
        'postal_code':this.postal_code,
        'email':this.email,
        }
        this.complete_Account_api(userdata).then(()=>{
            this.loading_comp = false;
            this.$router.push({path: '/booking'});    
        });
    }
  },
  mounted(){
    this.fill_data();
  }
};
</script>
<style lang="scss" scoped>
.login_wraps{
    padding-top: 120px;
    padding-bottom: 80px;
    min-height: 100vh;
    .form_complete{
        width: 80%;
        margin-left: auto;
        margin-right: auto;
    }
    h2{
        font-size: 1.8rem;
        font-weight: 500;
    }
    .wrapfields{
        margin-bottom: 20px;
    }
}

</style>